var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "inbox_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12h-6l-2 3h-4l-2-3H2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2 12 3.45-6.89A2 2 0 0 1 7.24 4h9.52a2 2 0 0 1 1.79 1.11L22 12v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgInbox as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMjIgMTJIMTZMMTQgMTVIMTBMOCAxMkgyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNMiAxMkw1LjQ1IDUuMTFDNS42MTU1OCA0Ljc3Njc5IDUuODcwODMgNC40OTYzNyA2LjE4NzA0IDQuMzAwMjhDNi41MDMyNiA0LjEwNDE5IDYuODY3OTIgNC4wMDAyIDcuMjQgNEgxNi43NkMxNy4xMzIxIDQuMDAwMiAxNy40OTY3IDQuMTA0MTkgMTcuODEzIDQuMzAwMjhDMTguMTI5MiA0LjQ5NjM3IDE4LjM4NDQgNC43NzY3OSAxOC41NSA1LjExTDIyIDEyVjE4QzIyIDE4LjUzMDQgMjEuNzg5MyAxOS4wMzkxIDIxLjQxNDIgMTkuNDE0MkMyMS4wMzkxIDE5Ljc4OTMgMjAuNTMwNCAyMCAyMCAyMEg0QzMuNDY5NTcgMjAgMi45NjA4NiAxOS43ODkzIDIuNTg1NzkgMTkuNDE0MkMyLjIxMDcxIDE5LjAzOTEgMiAxOC41MzA0IDIgMThWMTJaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";